/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for promptTypeValues. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="promptTypeValues"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="serverDetermined"/&gt; &lt;enumeration value="editBox"/&gt; &lt;enumeration value="selectDate"/&gt; &lt;enumeration value="selectDateTime"/&gt; &lt;enumeration value="selectInterval"/&gt; &lt;enumeration value="selectTime"/&gt; &lt;enumeration value="selectValue"/&gt; &lt;enumeration value="selectWithSearch"/&gt; &lt;enumeration value="selectWithTree"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class PromptTypeValues extends Enum{

	enumValue = null;

	/**
	 * Specifies that the prompt will be determined by the server during execution.
	 */
	static  SERVER_DETERMINED = PromptTypeValues.newLiteral("serverDetermined");

	/**
	 * Specifies that the prompt will be displayed as an edit box.
	 */
	static  EDIT_BOX = PromptTypeValues.newLiteral("editBox");

	/**
	 * Specifies that the prompt will display a selectable date.
	 */
	static  SELECT_DATE = PromptTypeValues.newLiteral("selectDate");

	/**
	 * Specifies that the prompt will display a selectable date and time.
	 */
	static  SELECT_DATE_TIME = PromptTypeValues.newLiteral("selectDateTime");

	/**
	 * Specifies that the prompt will display a selectable interval.
	 */
	static  SELECT_INTERVAL = PromptTypeValues.newLiteral("selectInterval");

	/**
	 * Specifies that the prompt will display a selectable time.
	 */
	static  SELECT_TIME = PromptTypeValues.newLiteral("selectTime");

	/**
	 * Specifies that the prompt will display a list of values from which the user can select.
	 */
	static  SELECT_VALUE = PromptTypeValues.newLiteral("selectValue");

	/**
	 * Specifies that the prompt will be displayed as a user-defined search. Note: Not applicable to a queryItem where usage is set to fact.
	 */
	static  SELECT_WITH_SEARCH = PromptTypeValues.newLiteral("selectWithSearch");

	static  SELECT_WITH_TREE = PromptTypeValues.newLiteral("selectWithTree");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < PromptTypeValues.values().length); ++i) {
			if (PromptTypeValues.values()[i].enumValue == v) {
				return PromptTypeValues.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("PromptTypeValues" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/PromptTypeValues.js